import { History as history, Routes as routes } from '../navigation';

const navigateTo = (route) => {
  if (route) {
    history.push(route);
  } else {
    console.log("No Route Passed")
  }
}

const navigateBack = () => {
  history.goBack();
}

const navigateToSignIn = () => {
  history.replace(routes.SIGN_IN);
}

const navigateToHome = () => {
  history.replace(routes.HOME);
}

export default {
  navigateBack,
  navigateTo,
  navigateToSignIn,
  navigateToHome,
}
